const Step4Data = {
  title: {
    pl: "Kalkulacja opłacalności wdrożenia\n systemu wizyjnego w Twojej firmie",
    en: "Calculation of the profitability of implementing\na vision system in your company",
  },
  subtitle: {
    pl: "Podsumowanie Twoich wyliczeń:",
    en: "Summary of your calculations:",
  },
  redbar: {
    pl: "Szacowana cena Systemu Wizyjnego dla Twojej produkcji",
    en: "Estimated price of the Vision System for your production",
  },
  pricetext: {
    pl: "Cena Systemu Wizyjnego:",
    en: "Price of the Vision System:",
  },
  roi: {
    pl: "Szacowane ROI:",
    en: "Estimated ROI:",
  },
  month: {
    pl: "msc",
    en: "months",
  },
  give: {
    pl: "Podaj adres email na który prześlemy Ci wynik w formie PDF",
    en: "Provide the email address to which we will send you the result in PDF form",
  },
  rodo: {
    pl: ' Wyrażam zgodę na otrzymywanie informacji handlowych środkami komunikacji elektronicznej wysyłanymi przez MV Center oraz na wykorzystanie komunikacji email w celach marketingowych (<a href="https://mv-center.com/rodo/" target="_blank">Polityka Prywatności</a>).',
    en: ' I consent to being contacted by telephone in order to handle this notification. I consent to receiving commercial information by electronic means of communication sent by MV Center and to the use of email communication for marketing purposes (<a href="https://mv-center.com/en/rodo/" target="_blank">Privacy Policy</a>).',
  },
  msgsend: {
    pl: "Wiadmość została wysłana",
    en: "The message was sent",
  },
  clear: {
    pl: "Zacznij od nowa (wyczyść\u00A0formularz)",
    en: "Start again (clear\u00A0form)",
  },
  atitle: {
    pl: "Miesięczny koszt kontrolerów jakości:",
    en: "Monthly cost of Quality Controllers:",
  },
  atitley: {
    pl: "Roczny koszt kontrolerów jakości:",
    en: "Annual cost of Quality Controllers:",
  },
  btitle: {
    pl: "Miesięcznie koszt brakowania:",
    en: "Monthly scrapping cost:",
  },
  btitley: {
    pl: "Roczny koszt brakowania:",
    en: "Annual scrapping cost:",
  },
  ctitle: {
    pl: "Rocznie koszty reklamacji:",
    en: "Annual Complaint costs:",
  },
  dtitle: {
    pl: "Miesięcznie koszt przetwarzania braków:",
    en: "Monthly cost of processing deficiencies:",
  },
  dtitley: {
    pl: "Roczny koszt przetwarzania braków:",
    en: "Annual cost of processing deficiencies:",
  },
  etitle: {
    pl: "Roczny koszt awarii:",
    en: "Annual cost of failure:",
  },
  unit: {
    pl: "PLN",
    en: "EUR",
  },
  contact: {
    title: {
      pl: "Informacje kontaktowe:",
      en: "Contact information:",
    },
    name: "MV Center Systemy Wizyjne Sp. z o.o.",
    address: {
      pl: "ul. Krakowska 50",
      en: "50 Krakowska Street",
    },
    addresscd: "32-083 Balice",
    nip: "NIP: 5130255480",
    mail: "kontakt@mv-center.com",
  },
  pdfdata: {
    pl: [
      {
        challenge: {
          id: "A",
          name: "Chcę zastąpić pracę kontrolerów oraz zwiększyć skuteczność kontroli",
        },
        inputs: [
          {
            label: "Ilość kontrolerów na zmianę:",
            id: "A1",
            value: "brak",
          },
          {
            label: "Ilość zmian na dzień produkcyjny:",
            id: "A2",
            value: "brak",
          },
          {
            label: "Ilość dni produkcyjnych w miesiącu:",
            id: "A3",
            value: "brak",
          },
          {
            label: "Stawka godzinowa (brutto) Kontrolera Jakości:",
            id: "A4",
            value: "brak",
          },
        ],
      },
      {
        challenge: {
          id: "B",
          name: "Chcę monitorować proces produkcji i dzięki temu zredukować koszty braków",
        },
        inputs: [
          {
            label: "Wolumen produkcyjny miesięczny:",
            id: "B1",
            value: "brak",
          },
          {
            label: "Procent brakowości przed wdrożeniem Systemu Wizyjnego:",
            id: "B2",
            value: "brak",
          },
          {
            label: "Koszt brakowania pojedynczego produktu:",
            id: "B3",
            value: "brak",
          },
        ],
      },
      {
        challenge: {
          id: "C",
          name: "Chcę uniknąć reklamacji od Klienta Końcowego",
        },
        inputs: [
          {
            label:
              "Ilość reklamacji przed Wdrożeniem Systemu Wizyjnego (rocznie):",
            id: "C1",
            value: "brak",
          },
          {
            label: "Średni koszt bezpośredni reklamacji:",
            id: "C2",
            value: "brak",
          },
          {
            label: "Koszty obsługi pojedynczej reklamacji:",
            id: "C3",
            value: "brak",
          },
        ],
      },
      {
        challenge: {
          id: "D",
          name: "Nie chcę niepotrzebnie przetwarzać braków",
        },
        inputs: [
          {
            label: "Wolumen produkcyjny miesięczny:",
            id: "D1",
            value: "brak",
          },
          {
            label:
              "Procent braków, które niepotrzebnie trafiają do dalszego procesu:",
            id: "D2",
            value: "brak",
          },
          {
            label:
              "Koszt przetwarzania (lakierowanie, wypalanie, drukowanie, transport etc) pojedynczego produktu:",
            id: "D3",
            value: "brak",
          },
        ],
      },
      {
        challenge: {
          id: "E",
          name: "Chcę zredukować koszty przestojów lub awarii spowodowanych błędem obsługi",
        },
        inputs: [
          {
            label:
              "Koszt pojedynczej awarii (wymiana formy/narzędzia w uszkodzonej maszynie, inne naprawy):",
            id: "E1",
            value: "brak",
          },
          {
            label: "Koszt postoju linii wywołanego błędęm obsługi:",
            id: "E2",
            value: "brak",
          },
          {
            label: "Ilość zdarzeń w roku:",
            id: "E3",
            value: "brak",
          },
        ],
      },
    ],
    en: [
      {
        challenge: {
          id: "A",
          name: "I’d like to replace the work of controllers and increase the effectiveness of inspections",
        },
        inputs: [
          {
            label: "Number of controllers per shift:",
            id: "A1",
            value: "empty",
          },
          {
            label: "Number of shifts per production day:",
            id: "A2",
            value: "empty",
          },
          {
            label: "Number of production days per month:",
            id: "A3",
            value: "empty",
          },
          {
            label: "Hourly rate of a Quality Controller:",
            id: "A4",
            value: "empty",
          },
        ],
      },
      {
        challenge: {
          id: "B",
          name: "I’d like to monitor the production process and thus reduce the costs of defects",
        },
        inputs: [
          {
            label: "Monthly production volume:",
            id: "B1",
            value: "empty",
          },
          {
            label:
              "Percentage of defects before the implementation of the Vision System:",
            id: "B2",
            value: "empty",
          },
          {
            label: "Cost of scrapping a single product:",
            id: "B3",
            value: "empty",
          },
        ],
      },
      {
        challenge: {
          id: "C",
          name: "I’d like to avoid complaints from the end customer",
        },
        inputs: [
          {
            label:
              "Number of complaints before the Implementation of the Vision System (annually):",
            id: "C1",
            value: "empty",
          },
          {
            label: "Average direct cost of a complaint:",
            id: "C2",
            value: "empty",
          },
          {
            label: "Costs of handling a single complaint:",
            id: "C3",
            value: "empty",
          },
        ],
      },
      {
        challenge: {
          id: "D",
          name: "I don’t want to process faulty components unnecessarily",
        },
        inputs: [
          {
            label: "Monthly production volume:",
            id: "D1",
            value: "empty",
          },
          {
            label:
              "Percentage of defects that are unnecessarily transferred to the next process:",
            id: "D2",
            value: "empty",
          },
          {
            label:
              "Cost of processing (varnishing, firing, printing, transport, etc.) of a single product:",
            id: "D3",
            value: "empty",
          },
        ],
      },
      {
        challenge: {
          id: "E",
          name: "I’d like to reduce the costs of downtime or failure caused by staff error",
        },
        inputs: [
          {
            label:
              "Cost of a single malfunction (replacement of a mold/tool in a damaged machine, other repairs):",
            id: "E1",
            value: "empty",
          },
          {
            label: "Cost of line downtime caused by staff error:",
            id: "E2",
            value: "empty",
          },
          {
            label: "Number of events per year:",
            id: "E3",
            value: "empty",
          },
        ],
      },
    ],
  },
  notdefined: {
    pl: "nie zdefiniowano",
    en: "not defined",
  },
  currentdate: {
    pl: "Data utworzenia raportu:",
    en: "Date of report creation:",
  },
  novision: {
    pl: "Koszt braku systemu wizyjnego",
    en: "The cost of not having a vision system",
  },
  savings: {
    pl: "Oszczędności z wdrożenia systemu wizyjnego",
    en: "Savings from implementing a vision system",
  },
  costvision: {
    pl: "Koszt systemu wizyjnego",
    en: "Cost of the vision system",
  },
};
export default Step4Data;
